<template>
<!-- ====================== 페이지내 내용 ====================== 

광고리스트가 표시된다.

리스트의 내용

| ㅁ | 아이콘(앱의 사진) | 게임명(광고의 이름) | 패키지 | 게시(게시의 여부) | 광고설정() |

선택 후 액선 버튼 모음 

| 게시 | 미게시 | 순서변경 | 등록 |

* 등록을 누르면 등록페이지로 넘어간다
 -> + 버튼을 추가하여 새로운 광고를 추가 할 수 있게 하며, 버튼에는 팁을 넣어주어서 새로운 광고라는 것을 알 수 있게 해준다.

* 순서변경을 누르면 순서를 변경할수 있는 페이지로 넘어간다.
 -> 순서변경 페이지를 따로 만들어 주어서 변경 작업이 진행 될 수 있도록 한다. 변경 버튼은 리스트 페이지에서 접근 할 수 있다.

* 수정은 데이터테이블의 curd를 통하여 버튼을 눌러서 진행 할 수 있도록 한다. 수정을 누르면 쿼리를 url에 넣어서 수정페이지로 넘겨준다.
-->


<div>
    <div class="py-3"></div>
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'light-blue darken-3'"
        dark
    >
        <v-toolbar-title>DAY7 광고리스트</v-toolbar-title>
        <v-spacer/>

    <v-btn
        class="mr-3"
        color='#37474F'
        @click="updateUseFlag('Y')"
        :disabled="selected[0]?false:true">
        게시
    </v-btn>
    <v-btn
        color='#37474F'
        @click="updateUseFlag('N')"
        :disabled="selected[0]?false:true">
        미게시
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="1000px"
    >
      <template v-slot:activator="{ on, attrs }">
    

        <v-btn
          class="ml-12"
          color='#37474F'
          dark
          v-bind="attrs"
          v-on="on"
        >
        <v-icon>mdi-swap-vertical</v-icon>
        순서 변경
        </v-btn>

      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">광고 리스트 순서 변경</span>
          <v-spacer></v-spacer>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog = false"
            :disabled ="false"
          >
            닫기
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="getAppInfoListForOrdewr"
            :disabled ="false"
          >
            리스트 복귀
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="appOrdering"
            :disabled ="false"
          >
            순서 변경
          </v-btn>
        </v-card-actions>
        </v-card-title>
        <v-card-text>
            <v-data-table
            v-if="dialog"
            :headers="headers2"
            :items="appInfoListForOrder"
            v-sortable-data-table
            @sorted="saveOrder"
            item-key="appName"
            class='row-height-50'
            hide-default-footer
            :items-per-page="-1"
            >
            <template v-slot:item.iconFilePath="{ item }">
                <img
                v-if="item.iconFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + item.iconFilePath.replace('files/', '/')" class="mt-2" style="width: 50px; height: 50px">
                <div
                v-else
                class="d-flex justify-center align-center mt-2"
                style="width: 50px; height: 50px; font-size: 10px;">
                no image
                </div>
            </template>
            </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn
        class="ml-12"
        color='indigo darken-3'
        to="/advertisement_regist">
        <v-icon>mdi-plus</v-icon>
        광고 등록
    </v-btn>

    </v-toolbar>
    <!-- ====================== 이쪽에 데이터테이블이 들어간다 ====================== -->
        <v-data-table
            v-model="selected"
            :headers="headers"
            :items="appInfoList"
            :single-select="false"
            item-key="appName"
            show-select
            :search="search"
            class="elevation-1"
        >
            <template v-slot:item.actions="{ item }">
            <v-btn
                small
                dark
                color='red'
                :to="`/advertisement_regist?appId=${item.appId}`">
                <v-icon small >mdi-pencil</v-icon>
                수정
            </v-btn>
            </template>
            <template v-slot:item.config="{ item }">
                <v-card
                    outlined
                    class="my-3 px-3">
                        <v-row>
                        <v-col
                            cols="6"
                            class="pt-0 pr-1"
                        >
                        <!-- item.config 안의 내용만을 사용하는 것이 아니라 그 외의 것도 사용하는 것이 가능하다 -->
                            <v-checkbox
                            v-model="item.appFrontAdFlag"
                            label="전면광고"
                            color="indigo"
                            :false-value="0"
                            :true-value="1"
                            dense
                            hide-details
                            ></v-checkbox>
                            <v-checkbox
                            v-model="item.appMidAdFlag"
                            label="중간광고"
                            color="indigo"
                            :false-value="0"
                            :true-value="1"
                            dense
                            hide-details
                            ></v-checkbox>
                            <v-checkbox
                            v-model="item.appFirstOrder"
                            label="우선노출"
                            color="indigo"
                            :false-value="0"
                            :true-value="1"
                            dense
                            hide-details
                            ></v-checkbox>
                        </v-col>
                        <v-col
                            cols="6"
                            class="pt-0 pl-1"
                        >
                            <v-checkbox
                            v-model="item.appMainAdFlag"
                            label="메인앱"
                            color="indigo"
                            :false-value="0"
                            :true-value="1"
                            dense
                            hide-details
                            ></v-checkbox>
                            <v-checkbox
                            v-model="item.appEndAdFlag"
                            label="종료팝업"
                            color="indigo"
                            :false-value="0"
                            :true-value="1"
                            dense
                            hide-details
                            ></v-checkbox>
                            <v-text-field
                                v-model="item.appRepeatCount"
                                label="반복노출수"
                                outlined
                                dense
                                hide-details
                                class="mt-3"
                            ></v-text-field>
                        </v-col>
                        </v-row>
                        <v-row
                            class="pb-3 px-3">

                            <v-btn
                                block
                                small
                                dark
                                color='green'
                                @click="setAdConfig(item)">
                                확인
                            </v-btn>

                        </v-row>
                </v-card>
            </template>
            <template v-slot:item.iconFilePath="{ item }">
                <img
                v-if="item.iconFilePath != null"
                :src="'https://day7adimageserver.s3.ap-northeast-2.amazonaws.com' + item.iconFilePath.replace('files/', '/')" class="mt-2" style="width: 150px; height: 150px">
                <div
                v-else
                class="d-flex justify-center align-center mt-2"
                style="width: 150px; height: 150px">
                    이미지 등록안됨
                </div>
            </template>
            <template v-slot:item.initiate="{ item }">
                <v-text v-if="item.initiate == true">Y</v-text>
                <v-text v-else>N</v-text>
            </template>
            

            <template v-slot:top>
                <v-spacer/>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    class="mr-4 ml-4 mb-3"
                ></v-text-field>
                <v-spacer/>
            </template>
        </v-data-table>
    </v-card>

        <div class="py-3"></div>
    <v-snackbar
      v-model="snackbar"
      :vertical="vertical"
    >
      {{ text }}
    </v-snackbar>
    </div>   
    
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',
    data: () => ({
        snackbar: false,
        text: '',
        vertical: true,
        selected:[],
        dialog:false,
        search:'',
        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,     
        mailTitle:'',
        mailMessage:'',
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        headers: [
            // 자바 서버의 변수 설정에 따라간다.            
           { text: '아이콘', value: 'iconFilePath', sortable: false, width:150 },
            { text: '게임명', value: 'appName', width:200 },
            { text: '패키지', value: 'appPackage' },
            { text: '게시', value: 'appUseFlag', width:80},
            { text: '광고설정', value: 'config', sortable: false, width:300 },
            { text: '수정', value: 'actions', sortable: false, width:116 }
        ],
        headers2: [
            { text: '아이콘', value: 'iconFilePath', sortable: false, width:150 },
            { text: '게임명', value: 'appName', sortable: false, width:200 },
            { text: '패키지', value: 'appPackage', sortable: false },
        ],
        appInfoList:[],
        appInfoListForOrder:[],
    }),

    created()
    {
        //this.end_date = moment().add(1,'M').format('yyyy-MM-DD');
        this.start_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.end_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.getAppInfoList();
    },

    methods:{
        saveOrder (event) {
        const movedItem = this.appInfoListForOrder.splice(event.oldIndex, 1)[0];
        this.appInfoListForOrder.splice(event.newIndex, 0, movedItem);
        },
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG',
            'GET_APP_INFO_LIST',
            'APP_ORDERING',
            'UPDATE_USE_FLAG',
            'UPDATE_AD_CONFIG'
        ]),
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
        async getAppInfoList(){
            console.log('광고 정버 데이터 가저오는 메서드 실행됨')
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            // 하나의 객체의 형태로 매개변수르 넣어주낟.
            this.appInfoList = Object.values(await this.GET_APP_INFO_LIST({selected_ad_os,selected_ad_language}))
            console.log('받아온 데이터',this.appInfoList)
        },
        // 순서 변경을 위한 리스트 배열을 가져오는 메서드
        async getAppInfoListForOrdewr(){
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            this.appInfoListForOrder = Object.values(await this.GET_APP_INFO_LIST({selected_ad_os,selected_ad_language}))
        },
        // 변경된 순서의 배열을 보내주어 광고 리스트 순서를 변경시키는 요청을 보내는 메서드
        async appOrdering(){
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const list_for_ordering = this.appInfoListForOrder
            await this.APP_ORDERING({selected_ad_os,selected_ad_language,list_for_ordering})
            this.text = '노출순서가 변경되었습니다.'
            this.snackbar = true
            this.getAppInfoListForOrdewr()
            this.getAppInfoList()
        },
        OnSearch_Event_Today()
        {//오늘자로만 검색해서 가져오도록 한다                              
            let log_type = 'REGIST';
            this.event_history_all = [];
            console.log(log_type);
            this.GET_LOG_TODAY({log_type}).then((body_data)=>{
                console.log("ADD_LOG_EVENT"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        DownloadData_Csv()
        {
            console.log('이벤트 다운로드 하기 ');
        },
        editItem()
        {
            alert('데이터 수정 클릭됨')
        },
        async setAdConfig(item){
            console.log('데이터테이블에서 받은 item',item)
            // 받아온 item.id를 보내준다.
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const app_id = item.appId
            const app_front_ad_flag = item.appFrontAdFlag
            const app_main_ad_flag = item.appMainAdFlag
            const app_mid_ad_flag = item.appMidAdFlag
            const app_end_ad_flag = item.appEndAdFlag
            const app_first_order = item.appFirstOrder
            const app_repeat_count = item.appRepeatCount
            await this.UPDATE_AD_CONFIG({
                selected_ad_os,
                selected_ad_language,
                app_id,
                app_front_ad_flag,
                app_main_ad_flag,
                app_mid_ad_flag,
                app_end_ad_flag,
                app_first_order,
                app_repeat_count,
            })
            this.text = '광고 설정이 적용되었습니다.'
            this.snackbar = true
            this.getAppInfoList()
        },
        async updateUseFlag(yn)
        {
            const selected_ad_os = this.osForWatch
            const selected_ad_language = this.langeageForWatch
            const selected_app_id = this.selectedAppId
            if(yn == 'Y'){
                // 개시 버튼이 눌러진 경우
                const app_use_flag = "Y"
                await this.UPDATE_USE_FLAG({selected_ad_os,selected_ad_language,selected_app_id,app_use_flag})
                this.text = '선택하신 광고가 개시되었습니다.'

            } else if (yn == 'N'){
                // 미개시 버튼이 눌러진 경우
                const app_use_flag = "N"
                await this.UPDATE_USE_FLAG({selected_ad_os,selected_ad_language,selected_app_id,app_use_flag})
                this.text = '선택하신 광고가 미개시되었습니다.'
            }
            this.selected = []
            this.snackbar = true
            this.getAppInfoList()
        },
    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
        },
        osForWatch () {
            return store.state.selected_ad_os
        },
        langeageForWatch () {
            return store.state.selected_ad_language
        },
        selectedAppId(){
            return this.selected.map((value) => {
                return value.appId
            })
        }
    },
    watch :{
        osForWatch: function() {
            this.getAppInfoList()
        },
        langeageForWatch: function() {
            this.getAppInfoList()
        },
        dialog: function() {
            // 변화가 감지되면 실행된다.
            if(this.dialog == true){
                console.log('순서변경을 위한 광고 리스트 가져오기 실행됨')
                this.getAppInfoListForOrdewr()
            } else {
                console.log('순서변경을 위한 배열 비움')
                this.appInfoListForOrder = []
            }
        }
    },
    components:{
    },
};
</script>